import {
  getPaymentCoupons,
  getPaymentRecommendCode,
  getShoppingInfor,
  removePaymentCoupons,
  removePaymentRecommendCode,
  setPaymentCoupons,
  setPaymentRecommendCode,
} from '@/utils/cookies'
import { ordercoupons } from '@/api/order'

export default {
  data() {
    return {
      showCodePicker: false, //选择推荐码弹窗
      showCouponsPicker: false, //选择优惠券弹窗
      recommend_code: '', //推荐码
      couponsArray: [], //优惠券数组
      isMyCoupon: false, //是否有可用优惠券
    }
  },
  methods: {
    // 更新推荐码
    updateRecommendCode(recommendCode) {
      this.recommend_code = recommendCode
      this.getOrderPrepare()
      setPaymentRecommendCode(this.products[0].no, recommendCode)
    },
    //更新优惠券
    updateCouponsArray(coupons) {
      this.couponsArray = coupons
      this.getOrderPrepare()
      setPaymentCoupons(this.products[0].no, coupons)
    },
    // 初始化优惠券和推荐码
    initCouponsAndRecommendCode() {
      const productNo = JSON.parse(getShoppingInfor())[0].product_no
      const paymentRecommendCode = getPaymentRecommendCode(productNo)
      const paymentCoupons = getPaymentCoupons(productNo)

      if (paymentRecommendCode) {
        this.recommend_code = paymentRecommendCode
      } else {
        this.removeCookieRecommendCode()
      }

      if (paymentCoupons?.length > 0) {
        this.couponsArray = paymentCoupons
      } else {
        this.removeCookieCoupons()
      }
    },
    // 清除推荐码cookie
    removeCookieRecommendCode() {
      const productNo = JSON.parse(getShoppingInfor())[0].product_no
      removePaymentRecommendCode(productNo)
    },
    // 清除优惠券cookie
    removeCookieCoupons() {
      const productNo = JSON.parse(getShoppingInfor())[0].product_no
      removePaymentCoupons(productNo)
    },
    // 清除推荐码和优惠券cookie
    removePaymentRecommendCodeAndCoupons() {
      this.removeCookieRecommendCode()
      this.removeCookieCoupons()
    },
    getCouponsPrepare() {
      ordercoupons(this.orderPrepareFixedParam()).then((res) => {
        // 请求成功
        if (res.status === 1) {
          this.isMyCoupon = res?.data?.usable_list?.length > 0
        }
      })
    },
  },
}
